module.exports = __webpack_public_path__ + "static/media/single-select.528a0c87.gif";